<div class="contact-container w-full"
  [ngStyle]="{ padding: linePadding }"
>
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>

  <div class="flex justify-center">
    <div *ngIf="contactFormType === 'email-form'" class="w-full">
      <form (ngSubmit)="onSubmit()" #contactForm="ngForm" novalidate>
        <!-- Name + Email -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Name (required) -->
          <input
            type="text"
            id="name"
            name="name"
            placeholder="*Name"
            class="w-full border rounded-lg px-4 py-3 outline-none focus:ring-2"
            [(ngModel)]="contact.name"
            required
            #nameModel="ngModel"
            [ngClass]="{
              'border-gray-300 focus:ring-gray-800': !(nameModel.invalid && (nameModel.touched || contactForm.submitted)),
              'border-red-500 ring-1 ring-red-500 focus:ring-red-600': nameModel.invalid && (nameModel.touched || contactForm.submitted)
            }"
            [attr.aria-invalid]="nameModel.invalid && (nameModel.touched || contactForm.submitted)"
          />

          <!-- Email (required) -->
          <input
            type="email"
            id="email"
            name="email"
            placeholder="*Email"
            class="w-full border rounded-lg px-4 py-3 outline-none focus:ring-2"
            [(ngModel)]="contact.email"
            required
            #emailModel="ngModel"
            [ngClass]="{
              'border-gray-300 focus:ring-gray-800': !(emailModel.invalid && (emailModel.touched || contactForm.submitted)),
              'border-red-500 ring-1 ring-red-500 focus:ring-red-600': emailModel.invalid && (emailModel.touched || contactForm.submitted)
            }"
            [attr.aria-invalid]="emailModel.invalid && (emailModel.touched || contactForm.submitted)"
          />
        </div>

        <!-- Phone (optional) -->
        <input
          type="tel"
          id="phone"
          name="phone"
          placeholder="Phone number"
          class="w-full border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-gray-800 mt-4"
          [(ngModel)]="contact.phone"
          #phoneModel="ngModel"
        />

        <!-- Comment (required) -->
        <textarea
          id="message"
          name="message"
          placeholder="*Comment"
          class="w-full min-h-[140px] border rounded-lg px-4 py-3 outline-none focus:ring-2 mt-4"
          [(ngModel)]="contact.message"
          required
          minlength="1"
          maxlength="600"
          (ngModelChange)="onMessageInput($event)"
          #messageModel="ngModel"
          [ngClass]="{
            'border-gray-300 focus:ring-gray-800': !((messageModel.invalid || (contact?.message?.length||0) > maxMessageLength) && (messageModel.touched || contactForm.submitted)),
            'border-red-500 ring-1 ring-red-500 focus:ring-red-600': (messageModel.invalid || (contact?.message?.length||0) > maxMessageLength) && (messageModel.touched || contactForm.submitted)
          }"
          [attr.aria-invalid]="(messageModel.invalid || (contact?.message?.length||0) > maxMessageLength) && (messageModel.touched || contactForm.submitted)"
        ></textarea>

        <div class="mt-1 text-sm text-right"
             [ngClass]="{ 'text-red-600': (contact?.message?.length||0) > maxMessageLength }">
          {{ contact?.message?.length || 0 }} of 600 max characters
        </div>

        <button
          class="w-full rounded-lg px-4 py-3 font-semibold text-white bg-primary hover:opacity-90 disabled:opacity-50 mt-6"
          type="submit"
          [disabled]="!contactForm.form.valid || (contact?.message?.length || 0) > maxMessageLength"
        >
          Send
        </button>
      </form>

    </div>
  </div>
</div>
